<template>
  <div class="ellipsis_tooltip_wrap" @mouseenter="show" @mouseleave="hide" @focusin="show" @focusout="hide" @keydown.esc="hide">
    <span ref="text" class="ellipsis_tooltip_text z_ellipsis1">{{ text }}</span>
    <span v-show="visible" ref="bubble" role="tooltip" class="ellipsis_tooltip_bubble" :style="bubbleStyle">{{ text }}</span>
  </div>
</template>
<script>
export default {
  props: { text: { type: [String, Number], default: '' } },
  data() { return { visible: false, bubbleStyle: {} } },
  watch: { text() { this.hide() } },
  mounted() {
    // Outside clipping/stacking contexts, including cards and scrolling lists.
    document.body.appendChild(this.$refs.bubble)
    window.addEventListener('resize', this.hide)
    window.addEventListener('scroll', this.hide, true)
  },
  deactivated() { this.hide() },
  beforeDestroy() {
    window.removeEventListener('resize', this.hide)
    window.removeEventListener('scroll', this.hide, true)
    const bubble = this.$refs.bubble
    if (bubble && bubble.parentNode) bubble.parentNode.removeChild(bubble)
  },
  methods: {
    hide() { this.visible = false },
    show() {
      const el = this.$refs.text
      if (!el || !this.text || el.scrollWidth <= el.clientWidth) return
      this.visible = true
      this.$nextTick(() => {
        if (!this.visible) return
        const anchor = el.getBoundingClientRect()
        const bubble = this.$refs.bubble.getBoundingClientRect()
        const left = Math.max(8, Math.min(anchor.left, window.innerWidth - bubble.width - 8))
        const above = anchor.top - bubble.height - 8
        const top = above >= 8 ? above : Math.min(anchor.bottom + 8, window.innerHeight - bubble.height - 8)
        this.bubbleStyle = { left: left + 'px', top: Math.max(8, top) + 'px' }
      })
    }
  }
}
</script>
<style>
.ellipsis_tooltip_wrap { position: relative; min-width: 0; }
.ellipsis_tooltip_text { display: block; width: 100%; line-height: inherit; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ellipsis_tooltip_bubble { position: fixed; z-index: 100100; width: max-content; max-width: min(360px, calc(100vw - 16px)); max-height: calc(100vh - 16px); overflow: hidden; padding: 8px 12px; line-height: 20px; color: var(--common-surface-color, #fff); font-size: 14px; font-weight: 400; white-space: normal; overflow-wrap: anywhere; background: var(--common-text-color, #282828); border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,.2); pointer-events: none; box-sizing: border-box; }
</style>
